import { dndTypes } from '../constants';
import { DropTarget } from 'react-dnd';
import DropField from './DropField'


const fieldTarget = {
  drop(props, monitor) {
    props.setField(monitor.getItem().label);
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
  };
}

export default DropTarget(dndTypes.fileItem, fieldTarget, collect)(DropField);
